import { jsxs as R, jsx as p } from "react/jsx-runtime";
import { cn as k } from "./designsystem-ui-react47.js";
import { forwardRef as T, Children as A, isValidElement as i } from "react";
import { CardActions as B } from "./designsystem-ui-react59.js";
import { CardBadge as L } from "./designsystem-ui-react60.js";
import { CardContent as N } from "./designsystem-ui-react61.js";
import { CardContext as S } from "./designsystem-ui-react62.js";
import { CardDescription as D } from "./designsystem-ui-react63.js";
import { CardDivider as I } from "./designsystem-ui-react64.js";
import { CardFooter as P } from "./designsystem-ui-react65.js";
import { CardHeader as j } from "./designsystem-ui-react66.js";
import { CardImage as E } from "./designsystem-ui-react67.js";
import { CardLayout as c } from "./designsystem-ui-react68.js";
import { CardMeta as F } from "./designsystem-ui-react69.js";
import { CardRating as H } from "./designsystem-ui-react70.js";
import { CardTags as M } from "./designsystem-ui-react71.js";
import { CardTime as z } from "./designsystem-ui-react72.js";
import { CardTitle as O } from "./designsystem-ui-react73.js";
const l = T(
  ({
    variant: n = "default",
    hasShadow: f = !1,
    hasBorder: C = !0,
    as: u,
    href: r,
    to: e,
    className: g,
    children: d,
    ...w
  }, y) => {
    const o = !!(r || e), a = u ?? (o ? "a" : "article"), b = r && a === "a" ? { href: r } : e && a !== "a" ? { to: e } : {}, v = {
      default: `tw-bg-surface-default tw-text-ink-default ${C ? "tw-border tw-border-ink-border-subtle hover:tw-border-ink-border-default" : ""}`,
      inverted: "tw-bg-button-primary-bg tw-text-button-primary-text",
      transparent: "tw-bg-base-transparent"
    };
    let s = d;
    const t = A.toArray(d), h = t.some(
      (m) => i(m) && m.type.displayName === "CardLayout"
    ), x = t.length === 2 && i(t[0]) && i(t[1]) && t[0].type.displayName === "CardImage" && t[1].type.displayName === "CardContent";
    return !h && x && (s = /* @__PURE__ */ R(c, { direction: "responsive", children: [
      t[0],
      t[1]
    ] })), /* @__PURE__ */ p(S.Provider, { value: { variant: n, isLink: o }, children: /* @__PURE__ */ p(
      a,
      {
        className: k(
          "tw-@container tw-rounded-card-lg tw-overflow-clip tw-block tw-no-underline",
          f && "tw-drop-shadow-md",
          v[n],
          o && "tw-group",
          g
        ),
        ref: y,
        ...b,
        ...w,
        children: s
      }
    ) });
  }
);
l.displayName = "Card";
const V = {
  content: {
    variant: "default",
    hasShadow: !0,
    layout: {
      direction: "responsive"
    },
    image: {
      aspectRatio: "5/4"
    },
    content: {
      padding: "responsive"
    }
  },
  recipe: {
    variant: "default",
    hasShadow: !0,
    layout: {
      direction: "vertical"
    },
    image: {
      aspectRatio: "5/4",
      responsive: !1
    },
    content: {
      padding: "responsive"
    }
  },
  section: {
    variant: "transparent",
    hasShadow: !1,
    layout: {
      direction: "horizontal"
    },
    image: {
      aspectRatio: "video"
    },
    content: {
      padding: "large"
    }
  }
}, W = Object.assign(l, {
  Layout: c,
  Image: E,
  Content: N,
  Title: O,
  Description: D,
  Tags: M,
  Meta: F,
  Header: j,
  Time: z,
  Rating: H,
  Badge: L,
  Actions: B,
  Divider: I,
  Footer: P,
  Presets: V
}), st = W;
export {
  st as Card,
  V as CardPresets
};
